package com.iptvplayer.shared.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class User(
    val id: String,
    val username: String,
    val email: String,
    val createdAt: Long,
    val isAdmin: Boolean = false
)

@Serializable
data class AuthToken(
    val accessToken: String,
    val refreshToken: String,
    val expiresAt: Long
)

@Serializable
data class AuthResponse(
    val user: User,
    val tokens: AuthToken
)
